// SPDX-License-Identifier: Apache-2.0
import Feature from 'ol/Feature';
import Layer from './layer';
import Geometry from 'ol/geom/Geometry';
import { Extent } from 'ol/extent';
import ILayerWithLegend from './ilayerwithlegend';
import { LayerId } from '../layerdefinitions';

/*
 * This class is a used in the state of the application, which will be accessed behind a javascript proxy.
 * This means that each modification made to its properties must come from outside,
 * because they have to be made through the proxy, so that the modification can be listen.
 * Therefore, this class must not contain any method which is updating a value directly
 * For example, any method doing <this.xxx = value> is forbidden here, because the modification be known from the proxy
 */
class LayerLocalFile extends Layer implements ILayerWithLegend {
  public _features: Feature<Geometry>[];
  public lastModifiedDate: string;
  public legend: boolean = true;
  public override isLegendExpanded: boolean;
  public wasLegendExpanded: boolean;
  public extent: Extent;
  private readonly file: File;
  private readonly locale: string;

  public constructor(
    id: LayerId,
    order: number,
    file: File,
    features: Feature<Geometry>[],
    extent: Extent,
    locale: string,
    options?: { isDefaultChecked?: boolean }
  ) {
    super(id, file.name, order, { isDefaultChecked: options?.isDefaultChecked ?? true });
    this._features = features;
    this.extent = extent;
    this.file = file;
    this.locale = locale;
    this.lastModifiedDate = new Date(file.lastModified).toLocaleDateString(locale);
    this.isLegendExpanded = true;
    this.wasLegendExpanded = false;
  }

  public clone(): LayerLocalFile {
    const clonedObject = new LayerLocalFile(this.id, this.order, this.file, this._features, this.extent, this.locale, {
      isDefaultChecked: this.isDefaultChecked
    });
    clonedObject.activeState = this.activeState;
    clonedObject.opacity = this.opacity;
    clonedObject.isLegendExpanded = this.isLegendExpanded;
    clonedObject.wasLegendExpanded = this.wasLegendExpanded;
    return clonedObject;
  }
}

export default LayerLocalFile;
